import { styled, theme } from "@theme/stitches.config"

export const SelectWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    "& span": {
        margin: 0
    }
})

export const Wrapper = styled("div", {
    borderRadius: 6,
    height: 48,
    maxHeight: 48,
    backgroundColor: theme.colors.N0,
    m: 0,
    mt: 8,
    "& select": {
        height: 48,
        "-webkit-appearance": "none",
        "-moz-appearance": "none",
        appearance: "none",
        "-ms-appearance": "none" /* get rid of default appearance for IE8, 9 and 10 */
    }
})

export const Styledselect = styled("select", {
    background: "url(\"data:image/svg+xml,%3Csvg width='11' height='6' viewBox='0 0 11 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m5.082 6 5-6h-10l5 6Z' fill='%238A8D8F'/%3E%3C/svg%3E\") no-repeat",
    width: "100%",
    border: 0,
    backgroundColor: theme.colors.N0,
    backgroundPosition: "right 20px center",
    borderRadius: 6,
    maxHeight: 48,
    p: 10
})
